/* ReviewAndInstall.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { useGetAppDetailsFromSearch } from '@atlassian/mpac-app-listing';
import { InstallableAppPrivacyInformation } from '@atlassian/mpac-installation';
import { H4 } from '@atlassian/mpac-primitives';
import { MarketplacePartnerType } from '@atlassian/mpac-types/graphql-gateway-types';
import { InstallDialogEditionHeader as AppHeader } from '@atlassian/mpac-ui';
import { makeAppHeaderDetails } from '../../../types/AppHeader';
import Pricing from '../../common/Pricing/container/PricingContainer';
import { isInstallableAppCloudFortified } from '../../InstallAppDialog/utils/installableApp';
import { useLinkTemplates } from '../hooks/useLinkTemplates';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _6 = "._1bahesu3{justify-content:flex-end}";
const _5 = "._19pkpxbi{margin-top:var(--ds-space-200,1pc)}";
const _4 = "._2lx21bp4{flex-direction:column}";
const _3 = "._1e0c1txw{display:flex}";
const _2 = "._ect418aq{font-family:var(--ds-font-family-brand-body,\"Charlie Text\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const _ = "._zulpxy5q{gap:var(--ds-space-400,2pc)}";
const pricingContainerStyles = null;
const reviewAndInstallScreenStyles = null;
export const ReviewAndInstall = _ref => {
  var _installableApp$marke;
  let {
    baseData,
    appInstallConfig,
    appKey
  } = _ref;
  const links = useLinkTemplates({
    adminHubBaseUrl: appInstallConfig.adminHubBaseUrl,
    mpacBaseUrl: appInstallConfig.mpacBaseUrl,
    mpacCdnBaseUrl: appInstallConfig.mpacCdnBaseUrl,
    macBaseUrl: appInstallConfig.macBaseUrl,
    wacBaseUrl: appInstallConfig.wacBaseUrl,
    atlassianCommunityBaseUrl: appInstallConfig.atlassianCommunityBaseUrl
  });
  const {
    installMode,
    hostData: {
      hostLicense
    }
  } = baseData;
  const appDetailsFromSearchResponse = useGetAppDetailsFromSearch({
    algoliaConfig: appInstallConfig.algoliaConfig,
    appKey
  });
  const {
    installableApp,
    installedApp
  } = installMode;
  const hostPricing = {
    pending: false,
    result: hostLicense,
    error: null
  };
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4]
    }), /*#__PURE__*/_jsxs("div", {
      className: ax(["_zulpxy5q _ect418aq _1e0c1txw _2lx21bp4"]),
      children: [/*#__PURE__*/_jsx(H4, {
        children: "Review and Install"
      }), /*#__PURE__*/_jsx(AppHeader, {
        appHeaderDetails: makeAppHeaderDetails(installableApp.marketplaceAppDetails, appDetailsFromSearchResponse),
        appIconLink: links.appIcon,
        appRatingLink: links.appRating,
        isAppCloudFortified: isInstallableAppCloudFortified(installableApp),
        openMarketplaceLinksInNewTab: true,
        bugBountyParticipant: (_installableApp$marke = installableApp.marketplaceAppDetails.programs) === null || _installableApp$marke === void 0 ? void 0 : _installableApp$marke.bugBountyParticipant,
        headerInjection: /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_5, _3, _6]
          }), /*#__PURE__*/_jsx("div", {
            className: ax(["_19pkpxbi _1e0c1txw _1bahesu3"]),
            children: /*#__PURE__*/_jsx(Pricing, {
              hostPricing: hostPricing,
              appKey: installableApp.details.key,
              links: links,
              installedApp: installedApp,
              paymentModel: installableApp.marketplaceAppDetails.paymentModel,
              mpacBaseUrl: appInstallConfig.mpacBaseUrl,
              eligibleForFreeOnSandbox: installableApp.eligibleForFreeOnSandbox,
              cloudMigrationTrial: installableApp.cloudMigrationTrial
            })
          })]
        })
      }), /*#__PURE__*/_jsx(InstallableAppPrivacyInformation, {
        links: links,
        appName: installableApp.marketplaceAppDetails.name,
        partner: {
          name: installableApp.marketplaceAppDetails.vendor.name,
          type: installableApp.marketplaceAppDetails.vendor.vendorType === 'internal' ? MarketplacePartnerType.AtlassianInternal : null
        },
        privacyPolicyUrl: installableApp.marketplaceAppDetails.privacyPolicy,
        endUserLicenseAgreementUrl: installableApp.marketplaceAppDetails.eula,
        appIdentifier: baseData.appIdentifier
      })]
    })]
  });
};